<div class="box is-paddingless">
    @if (plan?.data?.plan_flag) {
        <header class="box-header header-custo is-justified-center is-blue-byou">
            <p class="text">
                {{ plan.data.plan_flag }}
            </p>
        </header>
    }
    <checkout-card-offer-byou
        [plan]="plan"
        [quoteIndex]="quoteIndex"
        (addProductEvent)="addProductEvent($event)"
        (removeProductEvent)="removeProductEvent($event)"
        (setLockedEvent)="setLocked(plan, $event)"
        [isLoading]="isLoading"
        [cartForm]="cartForm"
        [atLeastOneOfferHasPromoHome]="atLeastOneOfferHasPromoHome"
        [hasHat]="!!plan.data.plan_flag"
    />
</div>
